import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchSaleProducts } from '../../../store/actions/sale-product.action';
import ProductCard from '../../../components/homepage/ProductCard/ProductCard';
import ROUTER from '../../../routers/Routers';
import { useNavigate } from 'react-router-dom';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const SectionTopProduct = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [id] = useState();
  const [offset] = useState(0);
  const [limit] = useState(20);

  const fetchProducts = useCallback(() => {
    dispatch(fetchSaleProducts({ offset, limit, productId: id, country_code }))
      .then(action => {
        if (action?.payload?.data) {
          const { data } = action.payload;
          if (offset) setProducts(prev => [...prev, ...data]);
          else setProducts([...data]);
        }
      })
      .catch(() => {
        // Xử lý lỗi nếu cần
      });
  }, [id, offset, limit, country_code]);

  useEffect(() => {
    fetchProducts();
  }, [id, offset, limit]);

  return (
    <div className="section-top-product flex w-full lg:py-[60px] lg:px-[80px] px-[16px] py-[32px] flex-col items-start lg:gap-[32px] gap-[16px] cursor-pointer">
      <span className="lg:h1 text-headline-small ">{t('Top Products')}</span>
      <div className="flex justify-center items-center self-stretch">
        <div className="justify-start items-start gap-4 grid 3xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
          {products.map((item, i) => {
            return (
              <ProductCard
                key={i}
                item={{
                  ...item,
                  priceAfter: item.price_after || 0,
                  priceOriginal: item.price_original || 0,

                  images: [
                    ...(item.image_urls?.map(icon => ({ src: icon })) || []),
                    ...(item.images?.map(icon => ({ src: icon })) || []),
                  ],
                }}
                tags={
                  item.discount_value
                    ? [
                        {
                          label:
                            item.discount_type === 'PERCENT_DISCOUNT'
                              ? `${item.discount_value}%`
                              : `${convertForeignCurrency(item.discount_value)}`,
                          className:
                            'bg-primary-secondary py-[4px] px-[8px] rounded-[4px]',
                        },
                      ]
                    : null
                }
                onClick={() => navigate(ROUTER.PRODUCT_DETAIL + '/' + item.id)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SectionTopProduct;
